export default "__VITE_ASSET__B1kdm_g9__"